import { render, staticRenderFns } from "./NumericStepper.vue?vue&type=template&id=3830fffa&scoped=true&"
import script from "./NumericStepper.vue?vue&type=script&lang=ts&"
export * from "./NumericStepper.vue?vue&type=script&lang=ts&"
import style0 from "./NumericStepper.vue?vue&type=style&index=0&id=3830fffa&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3830fffa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
